// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vc-logs-has-cmd {\n  padding-bottom: 6.15384615em;\n}\n", "",{"version":3,"sources":["webpack://./src/log/log.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;AADF","sourcesContent":["@import \"../styles/var.less\";\n\n.vc-logs-has-cmd {\n  padding-bottom: (80em / @font);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
